import { ProvinceAbbreviations } from "../../../helpers/constant";
import { countryOptions } from "../../patient/create/options";
import { DataField, P } from "../components/common-components";

export const GetPatientAddress = ({ className, patient, showLabel = true, vertical = true }) => {
  return (
    <>
      {patient?.contactInfo?.longTermCare ? (
        <>
          <P className={`font-semibold`}>Living in long term care</P>
          <DataField
            label="Name of Facility"
            value={patient?.contactInfo?.nameOfFacility || "N/A"}
            vertical
          />
        </>
      ) : null}
      {!patient?.contactInfo?.longTermCare && patient?.contactInfo?.address ? (
        <DataField
          vertical={vertical}
          label={showLabel ? "Address" : null}
          value={
            <div className={`${className}`}>
              {patient.contactInfo.address}
              {patient.contactInfo.unitNumber ? (
                <> {patient.contactInfo.unitNumber}</>
              ) : (
                ""
              )}
              {patient.contactInfo.poBox ? (
                <>
                  {", "}
                  {`PO Box ${patient.contactInfo.poBox}`}
                </>
              ) : (
                ""
              )}
              {patient.contactInfo.city ||
              ProvinceAbbreviations[patient.contactInfo.province] ||
              patient.contactInfo.postalCode ? (
                <>
                  {", "}
                  {[
                    patient.contactInfo.city || "",
                    ProvinceAbbreviations[patient.contactInfo.province] || "",
                    patient.contactInfo.postalCode
                      ? `${patient.contactInfo.postalCode.slice?.(
                          0,
                          3
                        )} ${patient.contactInfo.postalCode.slice?.(3)}`.trim()
                      : "",
                  ].join(" ")}
                </>
              ) : null}
              {patient.contactInfo.country ? (
                <>
                  {", "}
                  {
                    countryOptions.find(
                      (c) => c.value === patient.contactInfo.country
                    )?.label
                  }
                </>
              ) : null}
            </div>
          }
        />
      ) : (
        <P className="font-semibold">No Permanent Address</P>
      )}
    </>
  );
};
